import "core-js/modules/es.array.reduce";
import getClassicLink from './get-classic-link';
import globals from '../../../../../globals/globals';
import MastheadBarButtonRecord from '../../../../../records/MastheadBarButtonRecord';
export default function mapBarSectionLinks(links) {
  return links.reduce(function (validItems, barLink) {
    if (!(barLink.navigationId === 'UNREAD_MESSAGE' && !globals().customerUnreadMessages)) {
      validItems.push(new MastheadBarButtonRecord(getClassicLink(barLink)));
    }

    return validItems;
  }, []);
}